import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO component for standard Meta tags, OpenGraph, Twitter Cards,
 * and semantic JSON-LD structured data.
 */
export default function SEO({ title, description, url, image, schema, type = "website", keywords }) {
  const siteName = "AmagicTech Solutions";
  const defaultTitle = `${siteName} | Web, Mobile, AI & Digital Services`;
  const defaultDescription =
    "AmagicTech Solutions — engineering studio for web, mobile, AI & digital products. Built from Coimbatore & Muscat for clients worldwide.";
  const defaultImage = "https://amagictechsolutions.com/brand/favicon-512.png";
  const defaultKeywords =
    "software development, web development company, mobile app development, custom web applications, AI integration services, UI UX design studio, SaaS development, Coimbatore, Muscat Oman, React Native, Next.js, Node.js";

  let finalTitle = defaultTitle;
  if (title) {
    finalTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;
  }

  const finalDescription = description || defaultDescription;
  const finalImage = image
    ? image.startsWith("http")
      ? image
      : `https://amagictechsolutions.com${image}`
    : defaultImage;
  const finalUrl = url ? `https://amagictechsolutions.com${url.startsWith("/") ? url : `/${url}`}` : "https://amagictechsolutions.com";
  const finalKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={finalUrl} />

      {/* OpenGraph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={finalUrl} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
      <meta name="twitter:site" content="@amagictech" />

      {/* JSON-LD Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
